import {decorate, observable} from 'mobx';
import {EntityStore} from './entityStore';
import {PopupMessage} from '../models/popupMessage';

export class PopupMessageStore extends EntityStore {
  messages = [];
  constructor(rootStore) {
    super(rootStore, 'messages', null, PopupMessage);
  }
}

decorate(PopupMessageStore, {
  messages: observable,
});
